<!-- Lounges -->
<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    <div [class.duplicate-item-wrapper]="duplicateBooking">
      @if (duplicateBooking) {
        <div class="duplicate-item-date">
          <i class="ico-lounge ico-material"></i>&nbsp;
          <span i18n="@@taxisDate">Date:</span>
          <strong>{{ lounge.detail.arrivalDatetime | sabsDate: 5 }}</strong>
        </div>
      }
      <div [class.duplicate-item-info]="duplicateBooking">
        <div class="cart_item_heading">
          @if (!duplicateBooking) {
            <i class="ico-lounge ico-material"></i>&nbsp;
          }
          <strong>{{ lounge.detail.name }}</strong>
          @if (!duplicateBooking) {
            <section (mouseleave)="tt1.close()">
              <button
                class="cart_item_remove ico-trash"
                ngbTooltip="Remove  {{ lounge.detail.name }} from your {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                attr.aria-label="Remove  {{ lounge.detail.name }} lounge from your {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-ngbTooltip
                i18n-aria-label
                (click)="remove.emit()"
                triggers="manual"
                #tt1="ngbTooltip"
                (mouseenter)="tt1.open()"
                (focus)="tt1.open()"
                (blur)="tt1.close()"
                id="remove-basketitem-{{ lounge.id }}"
              ></button>
            </section>
          }
          @if (!duplicateBooking) {
            <section (mouseleave)="tt2.close()">
              <img
                src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                  displayItinerary ? 'luggage_icon' : 'basket_move'
                }}.svg"
                ngbTooltip="Move to different {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-ngbTooltip
                class="move_basket_icon"
                role="button"
                attr.aria-label="Move {{ lounge.detail.name }} lounge to different {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-aria-label
                (click)="openChangeModal.emit()"
                (keydown.enter)="openChangeModal.emit()"
                (keydown.space)="openChangeModal.emit()"
                triggers="manual"
                #tt2="ngbTooltip"
                (mouseenter)="tt2.open()"
                (focus)="tt2.open()"
                (blur)="tt2.close()"
                tabindex="0"
                id="share-basketitem-{{ lounge.id }}"
              />
            </section>
          }
        </div>
        @if (lounge.detail.destination) {
          <div
            class="cart_item_destination"
            id="lounge-{{ displayItinerary ? 'itinerary' : 'basket' }}-dest-{{ itemIndex }}"
          >
            <span i18n="@@ParkingSearchAirport">Airport:</span>
            {{ lounge.detail.destination }} ({{ lounge.detail.airportIata }})
          </div>
        }
        @if (lounge.searchQuery.terminal) {
          <div class="cart_item_destination">
            <span i18n="@@loungeBasketTerminal">Terminal:</span>
            {{ getTerminal(lounge.searchQuery.terminal) | translate }}
          </div>
        }
      </div>
    </div>

    @if (!duplicateBooking) {
      <div class="check_in">
        <span i18n="@@taxisDate">Date:</span>
        {{ lounge.detail.arrivalDatetime | sabsDate: 5 }}
      </div>
    }
    <div class="car_cart_item_to_point"></div>
    @if (!duplicateBooking) {
      @for (user of travellers; track user) {
        <div class="traveller-name">
          <b>{{ user.forename }}, {{ user.surname }}</b>
        </div>
      }
    }
    <div class="cart_item_price">
      @if (duplicateBooking) {
        <strong i18n="@@basketPanelCostLounges">Cost</strong>
      }
      <strong>{{ lounge.price | currency: lounge.currency }}</strong>
      @if (!duplicateBooking) {
        <em i18n="@@basketPanelTotalPriceLounges">&nbsp;Total Price</em>
      }
    </div>
  </div>
</div>
